import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { BUSINESS_INFO } from "../data";

export default function Footer() {
  return (
    <footer className="bg-[#F4EFE6] text-[#2C2523] pt-16 pb-12 border-t border-[#EADFCF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 pb-12 border-b border-[#EADFCF]">
          
          {/* Col 1: Brand & Intro */}
          <div className="space-y-4">
            <Logo variant="footer" light={false} />
            <p className="text-sm text-[#5C4D46] leading-relaxed pt-2">
              Grundig og professionel rengøring af sommerhuse, Airbnb, private hjem og dødsbo i Norddjurs samt skånsom vask og klip af hunde under 10 kg.
            </p>
            <div className="pt-2 flex flex-col gap-2">
              <a
                href={BUSINESS_INFO.facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-xs text-[#2C2523] hover:text-[#1A1513] bg-[#EADFCF]/70 hover:bg-[#EADFCF] px-3.5 py-2 rounded-lg transition-colors border border-[#D1C3B2] font-medium"
              >
                <i className="fa-brands fa-facebook text-base text-[#8C6D46]" aria-hidden="true"></i>
                <span>Følg os på Facebook</span>
              </a>
            </div>
          </div>

          {/* Col 2: Services Navigation */}
          <div>
            <h3 className="text-sm font-semibold text-[#2C2523] uppercase tracking-wider mb-4 font-heading">
              Ydelser
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/sommerhusrengoering" className="text-[#5C4D46] hover:text-[#2C2523] transition-colors inline-flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#8C6D46]" aria-hidden="true"></i>
                  <span>Sommerhusrengøring</span>
                </Link>
              </li>
              <li>
                <Link to="/airbnb-rengoering" className="text-[#5C4D46] hover:text-[#2C2523] transition-colors inline-flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#8C6D46]" aria-hidden="true"></i>
                  <span>Airbnb-rengøring</span>
                </Link>
              </li>
              <li>
                <Link to="/rengoering-af-hus-eller-lejlighed" className="text-[#5C4D46] hover:text-[#2C2523] transition-colors inline-flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#8C6D46]" aria-hidden="true"></i>
                  <span>Rengøring af hus eller lejlighed</span>
                </Link>
              </li>
              <li>
                <Link to="/toemning-af-doedsbo" className="text-[#5C4D46] hover:text-[#2C2523] transition-colors inline-flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#8C6D46]" aria-hidden="true"></i>
                  <span>Tømning af dødsbo, derefter rengøring</span>
                </Link>
              </li>
              <li>
                <Link to="/hundeklip-og-vask" className="text-[#5C4D46] hover:text-[#2C2523] transition-colors inline-flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#8C6D46]" aria-hidden="true"></i>
                  <span>Hundeklip & vask (under 10 kg)</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-[#2C2523] uppercase tracking-wider mb-4 font-heading">
              Sider
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-[#5C4D46] hover:text-[#2C2523] transition-colors">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/om-os" className="text-[#5C4D46] hover:text-[#2C2523] transition-colors">
                  Om os
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-[#5C4D46] hover:text-[#2C2523] transition-colors">
                  Kontakt os
                </Link>
              </li>
              <li>
                <a href={`tel:${BUSINESS_INFO.phone}`} className="text-[#5C4D46] hover:text-[#2C2523] transition-colors whitespace-nowrap">
                  Ring 40 94 75 40
                </a>
              </li>
            </ul>
          </div>

          {/* Col 4: Contact details */}
          <div>
            <h3 className="text-sm font-semibold text-[#2C2523] uppercase tracking-wider mb-4 font-heading">
              Kontakt Virksomheden
            </h3>
            <div className="space-y-3 text-sm text-[#5C4D46]">
              <p className="font-semibold text-[#2C2523]">{BUSINESS_INFO.name}</p>
              <p className="flex items-center gap-2.5">
                <i className="fa-solid fa-location-dot text-[#8C6D46] shrink-0" aria-hidden="true"></i>
                <span>{BUSINESS_INFO.fullAddress}</span>
              </p>
              <p className="flex items-center gap-2.5">
                <i className="fa-solid fa-phone text-[#8C6D46] shrink-0" aria-hidden="true"></i>
                <a href={`tel:${BUSINESS_INFO.phone}`} className="hover:text-[#2C2523] transition-colors whitespace-nowrap">
                  {BUSINESS_INFO.phoneFormatted}
                </a>
              </p>
              <p className="flex items-center gap-2.5">
                <i className="fa-solid fa-envelope text-[#8C6D46] shrink-0" aria-hidden="true"></i>
                <a href={`mailto:${BUSINESS_INFO.email}`} className="hover:text-[#2C2523] transition-colors whitespace-nowrap">
                  {BUSINESS_INFO.email}
                </a>
              </p>
              <p className="text-xs text-[#7C6A5E] leading-relaxed pt-1">
                Baseret i Ørsted (8950) kører vi ud til sommerhuse og ferieboliger i hele Norddjurs, herunder Fjellerup Strand, Bønnerup Strand, Auning, Allingåbro, Vivild, Udbyhøj og omegn.
              </p>
              <p className="flex items-center gap-2.5 pt-1 text-xs text-[#7C6A5E]">
                <i className="fa-solid fa-id-card shrink-0" aria-hidden="true"></i>
                <span>CVR: {BUSINESS_INFO.cvr}</span>
              </p>
            </div>
          </div>

        </div>

        {/* Bottom copyright */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between text-xs text-[#7C6A5E] gap-4">
          <p>© {new Date().getFullYear()} {BUSINESS_INFO.name}. Alle rettigheder forbeholdes.</p>
          <p>Rengøring af sommerhuse og Airbnb i {BUSINESS_INFO.area}</p>
        </div>
      </div>
    </footer>
  );
}
